export var neutral = {
  50: '#B7C4D1',
  100: '#9DACBC',
  200: '#8796A6',
  300: '#718090',
  400: '#5B6B7C',
  500: '#475666',
  600: '#2E3944',
  700: '#232B34',
  // extra colors
  10: '#F6F7F7',
  20: '#EEF1F4',
  30: '#E2E7ED',
  40: '#CDD6DF'
};
export var teal = {
  50: '#E5FBFF',
  100: '#D2F8FF',
  200: '#B2F4FF',
  300: '#77DFED',
  400: '#3CCBDC',
  500: '#00B7CC',
  600: '#008FA6',
  700: '#006882',
  800: '#00556C',
  900: '#004257'
};
export var purple = {
  50: '#EDEBFF',
  100: '#CBC4F4',
  200: '#A9A0DF',
  300: '#988DE0',
  400: '#796DCB',
  500: '#6554C0',
  600: '#5243AA',
  700: '#403294'
};
export var blue = {
  50: '#E0F3FF',
  100: '#B0D3F7',
  200: '#80B2EF',
  300: '#5193E9',
  400: '#2E79DA',
  500: '#0A5ECC',
  600: '#074CA6',
  700: '#033A81'
};
export var green = {
  50: '#DDFCEC',
  100: '#BBF4D8',
  200: '#96ECC3',
  300: '#70E4AD',
  400: '#4BCC90',
  500: '#1DB273',
  600: '#06905E',
  700: '#006C48'
};
export var red = {
  50: '#FFECEA',
  100: '#FFCEC4',
  200: '#FFB09E',
  300: '#FF9178',
  400: '#FF7452',
  500: '#F85228',
  600: '#DB3C14',
  700: '#BF2600'
};
export var yellow = {
  50: '#FFFBDF',
  100: '#FFF3C7',
  200: '#FFE9A5',
  300: '#FFDD78',
  400: '#FFD03C',
  500: '#FFC300',
  600: '#FFAA00',
  700: '#FF8A00'
};